
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-and-refund-policy",
      function () {
        return require("private-next-pages/payment-and-refund-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-and-refund-policy"])
      });
    }
  